import clsx from 'clsx';
import _ from 'lodash';
import { OrderVoucherType, OrderVoucherFragment } from '@src/generated/graphql';
import VoucherItem from './VoucherItem';

interface Props {
  className?: string;
  vouchers?: OrderVoucherFragment[];
}

function VoucherList({ className, vouchers }: Props): JSX.Element {
  const voucherCountByType = _.chain(vouchers)
    .groupBy('type')
    .mapValues((val) => val.reduce((acc, voucher) => acc + voucher.quantity, 0))
    .value();

  return (
    <div className={clsx('space-y-4', className)}>
      {Object.entries(voucherCountByType).map(([type, count]) => (
        <VoucherItem
          key={type}
          type={type as OrderVoucherType}
          quantity={count}
        />
      ))}
    </div>
  );
}

export default VoucherList;
